// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fold-tr{border:none!important}.tableBox article .tableWrap td.plus{color:#f26149}.tableBox article .tableWrap td.minus{color:#528deb}.textBold{font-weight:700}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
